import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useWaffles, useOnUserSelected } from '@pelotoncycle/waffles';
import React from 'react';
import { isUpArrowKey, isDownArrowKey, isEnterKey } from '@peloton/keyboard';
export var useCarouselFocusHandler = function useCarouselFocusHandler(optionsCount, defaultIndex, selectedIndex, setSelectedIndex) {
  var _useWaffles = useWaffles(),
      setNavigationPaused = _useWaffles.setNavigationPaused;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isActive = _React$useState2[0],
      setIsActive = _React$useState2[1];

  var currentIndex = selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : defaultIndex;
  var prevIndex = currentIndex > 0 ? currentIndex - 1 : optionsCount - 1;
  var nextIndex = currentIndex < optionsCount - 1 ? currentIndex + 1 : 0;
  var onPrevious = React.useCallback(function () {
    return setSelectedIndex(prevIndex);
  }, [prevIndex, setSelectedIndex]);
  var onNext = React.useCallback(function () {
    return setSelectedIndex(nextIndex);
  }, [nextIndex, setSelectedIndex]);
  useOnUserSelected(function () {
    setIsActive(true);
  });
  React.useEffect(function () {
    var boundKeyDown = function boundKeyDown(event) {
      return onKeyDown(event, setIsActive, onPrevious, onNext);
    };

    if (isActive && selectedIndex === null) {
      setSelectedIndex(defaultIndex);
    }

    if (isActive) {
      setNavigationPaused(true);
      document.body.addEventListener('keydown', boundKeyDown);
    } else {
      setNavigationPaused(false);
      document.body.removeEventListener('keydown', boundKeyDown);
    }

    return function () {
      setNavigationPaused(false);
      document.body.removeEventListener('keydown', boundKeyDown);
    };
  }, [isActive, setNavigationPaused, onPrevious, onNext, defaultIndex, selectedIndex, setSelectedIndex]);
  return {
    isActive: isActive,
    nextIndex: nextIndex,
    prevIndex: prevIndex
  };
};

var onKeyDown = function onKeyDown(event, setIsEntryActive, onPrevious, onNext) {
  if (isEnterKey(event)) {
    setIsEntryActive(false);
  } else if (isUpArrowKey(event)) {
    onPrevious();
  } else if (isDownArrowKey(event)) {
    onNext();
  }
};